import React, { useEffect, useState } from "react";
import { AddTopicModal } from "../AddTopicModal";
import { UserOutlined } from "@ant-design/icons";
import { api } from "services/api";
import Loading from "components/Loading";
import ReactQuill from "react-quill";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { Form, Modal } from "antd";

export const ViemForumModal = ({ ...props }) => {
	const { setIsOpen, isOpen, currentCourseData, isCourse } = props;
	const [topicsInfos, setTopicsInfos] = useState<any>();
	const [topicId, setTopicId] = useState<string>("");
	const [forumTopics, setForumTopics] = useState<any[]>();
	const [currentTopic, setCurrentTopic] = useState<any>();
	const [value, setValue] = useState<string>("");
	const [isOpenAddTopic, setIsOpenAddTopic] = useState<boolean>(false);
	const [courseForumId, setCourseForumId] = useState();
	const [form] = Form.useForm();

	const { id: userId } = useSelector((state: any) => state.app.user);

	const [ hiddenTopics, setHiddenTopics ] = useState<boolean>(false)
	const [ hiddenMessages, setHiddenMessages ] = useState<boolean>(true)

	const handleSendMessage = () => {
		api
			.post(`/topics/${topicId}/messages`, {
				id_topico: topicId,
				text: value,
				user_id: userId,
				is_active: true,
			})
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					api.get(`/topics/${topicId}/messages`).then((res) => {
						setTopicsInfos(res.data.data);
					});
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setValue("");
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	useEffect(() => {
		const loadData = async () => {
			if (userId && currentCourseData?.id) {
				switch (isCourse) {
					case true:
						await api
							.get(`/courses/${currentCourseData.id}/modules/users/${userId}`)
							.then(async (res) => {
								await api
									.get(`/forums/${res?.data?.data?.forum?.id}/topics`)
									.then((r) => {
										setForumTopics(r.data.data.topics);
									});

								setCourseForumId(res?.data?.data?.forum?.id);
							});
						break;
					case false:
						await api
							.get(`/forums/${currentCourseData.forum.id}/topics`)
							.then((r) => {
								setForumTopics(r.data.data.topics);
							});

						setCourseForumId(currentCourseData.forum.id);
						break;
				}
			}
		};

		loadData();
		setHiddenTopics(false)
		setHiddenMessages(true)
		// eslint-disable-next-line
	}, [userId, currentCourseData]);
	return (
		<Modal
			title={
				<p style={{ margin: 0 }}>
					Fórum {isCourse ? "do curso" : "da aula"}:{" "}
					{currentCourseData?.title}
				</p>
			}
			open={isOpen}
			maskClosable={false}
			footer={false}
			onCancel={() => {
				setIsOpen(!isOpen);
			}}
			width={800}
		>
			<div className="row">
				<AddTopicModal
					setIsOpen={setIsOpenAddTopic}
					isOpen={isOpenAddTopic}
					forumId={courseForumId}
					form={form}
					setForumTopics={setForumTopics}
				/>

				<div className={'row pe-0 '+ (hiddenTopics ? 'd-none' : '')} style={{ height: "615px" }}>
					<div className="mb-3 d-flex justify-content-end">
						<div>
							<button
								className="class-module__container__info__forum-topics__header__btn"
								onClick={() => setIsOpenAddTopic(!isOpenAddTopic)}
							>
								Criar tópico
							</button>
						</div>
					</div>

					<div className="class-module__container__info__forum-topics">
						{forumTopics &&
							forumTopics.map((module: any, index: number) => {
								const { id, created_at } = module;
								return (
									<div
										key={index}
										className="row mb-2"
										style={{ cursor: "pointer" }}
										onClick={() => {
											setTopicId(id);
											api.get(`/topics/${id}/messages`).then((res) => {
												setTopicsInfos(res.data.data);
											});
											setCurrentTopic(module);
											setHiddenTopics(true)
											setHiddenMessages(false)
										}}
									>
										{/* <div className="class-module__container__info__forum-topics__topic__img">
											<UserOutlined twoToneColor="#000" />
										</div> */}
										<div className="bg-body-secondary p-3 rounded">
											<p className="mb-2 fw-medium text-capitalize">{module.user?.username}</p>

											<p className="fs-6 lh-base text-body-secondary mb-3">
												{module.subject}
											</p>
											<div
												className="d-md-flex justify-content-between"
											>
												<small><p className="mb-0">{created_at}</p></small>
											</div>
										</div>
									</div>
								);
							})}

						{!forumTopics && (
							<div
								style={{
									height: "100%",
									width: "100%",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<Loading title="Tópicos" />
							</div>
						)}

						{forumTopics && !forumTopics?.length && (
							<div className="row text-center">

								<span className="mt-3">
									Não há tópicos disponíveis.
								</span>
							</div>
						)}
					</div>
				</div>

				<div className={'class-module__container__forum '+ (hiddenMessages ? 'd-none' : '')}>
					<div className="mb-2">
						<button className="btn btn-sm btn-light" onClick={() => { setHiddenMessages(true); setHiddenTopics(false) }}>Voltar</button>
					</div>
					<div className="overflow-y-auto p-3">
						<div className="d-flex justify-content-center mb-2">
							<div>
								<p className="text-center">
									<span className="fw-medium">Tópico</span><br/>
									<span className="fst-italic">{currentTopic?.subject}</span>
								</p>
							</div>
						</div>

						<div>
							<p className="fs-6 fw-medium mb-2">
								Comentários: 
							</p>
						</div>

						{!topicsInfos?.messages && (
							<p
								style={{
									height: "100%",
									width: "100%",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								Selecione um tópico para visualizar suas respectivas
								mensagens.
							</p>
						)}
						{topicsInfos?.messages?.length === 0 && (
							<p
								style={{
									height: "100%",
									width: "100%",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								Ainda não há mensagens para exibir nesse tópico.
							</p>
						)}
						{topicsInfos?.messages.map(
							(
								{ message, user }: { message: any; user: any },
								index: number
							) => {
								return (
									<div
										key={index}
										className="row mb-2"
									>
										{/* <div className="class-module__container__forum__topics-container__topic__img">
											<UserOutlined twoToneColor="#000" />
										</div> */}
										<div className="bg-info-subtle p-3 rounded">
											<div className="mb-2">
												<p className="fw-medium text-capitalize ">
													{user[0]?.username}
												</p>
											</div>
											<div
												dangerouslySetInnerHTML={{
													__html: `<p>${message.text}</p>`,
												}}
												className="mb-2"
											></div>
											<div className="fw-light">
												<small>
													<span>
														{message.created_at}
													</span>
												</small>
											</div>
										</div>
									</div>
								);
							}
						)}
					</div>

					<div>
						{topicsInfos?.messages && (
							<div className="">
								<ReactQuill theme="snow" value={value} onChange={setValue} placeholder="Comente sobre este tópico"/>
							</div>
						)}
						<div className="p-0 mt-2">
							<button style={{ display: "none" }}></button>

							{topicsInfos?.messages && (
								<button onClick={() => handleSendMessage()} className="btn btn-outline-info">Enviar</button>
							)}
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};
